import { render } from "./typeadmin.vue?vue&type=template&id=db3c1ca4"
import script from "./typeadmin.vue?vue&type=script&lang=js"
export * from "./typeadmin.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__